import { FC, useState } from "react";
import { LineStylePopup, OpacityPopup } from "shared/ui";
import type { MainLineSettings } from "../model";
import styles from "./styles/ToolSettingsModal.module.css";

type OpenPopup = "style" | "opacity" | null;

interface Props {
  value: MainLineSettings;
  onChange: (value: MainLineSettings) => void;
}

export const MainLineSection: FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState<OpenPopup>(null);
  const toggle = (p: OpenPopup) => setOpen((prev) => (prev === p ? null : p));

  return (
    <div className={styles.mainLineRow}>
      <span className={styles.mainLineLabel}>Main Line</span>
      <div className={styles.btnGroup}>
        <div className={styles.btnWrap}>
          <button className={styles.mainLineBtn} onClick={() => toggle("style")}>
            <span className={styles.colorPreview} style={{ backgroundColor: value.color }} />
            <span>{value.width}px</span>
          </button>
          {open === "style" && (
            <LineStylePopup
              color={value.color}
              width={value.width}
              onColorChange={(color) => onChange({ ...value, color })}
              onWidthChange={(width) => onChange({ ...value, width })}
              onClose={() => setOpen(null)}
            />
          )}
        </div>
        <div className={styles.btnWrap}>
          <button className={styles.mainLineBtn} onClick={() => toggle("opacity")}>
            <span>{value.opacity}%</span>
          </button>
          {open === "opacity" && (
            <OpacityPopup
              opacity={value.opacity}
              onChange={(opacity) => onChange({ ...value, opacity })}
              onClose={() => setOpen(null)}
            />
          )}
        </div>
      </div>
    </div>
  );
};
